import Button from "@material-ui/core/Button";
import Grid from "@material-ui/core/Grid";
import withStyles from "@material-ui/core/styles/withStyles";
import TextField from "@material-ui/core/TextField";
import get from "lodash/get";
import moment from "moment";
import { withSnackbar } from "notistack";
import React from "react";
import { FormattedMessage } from "react-intl";
import Select from "react-select";
import { instance } from "../../../../Actions/AxiosInstance";
import addressEmployee from "../../../../Assets/Images/work-experience.svg";
import If from "../../../../Component/Common/If";
import { DatePickerComponent } from "../../../../Component/Custom";
import createstore from "../../../../store";
import {
  convertDateForBackend,
  getEJ2CalenderMonthFormat,
} from "../../../../Utils";
import CreateComp from "../create";
import { NoRecordFound } from "../EmpMainProfile/NoRecordFound";

const styles = (theme) => ({
  colorSwitchBase: {
    color: "#166ab3",
    "&$colorChecked": {
      color: "#166ab3",
      "& + $colorBar": {
        backgroundColor: "#666",
      },
    },
  },
  colorBar: {},
  colorChecked: {},
  iOSSwitchBase: {
    "&$iOSChecked": {
      color: "#166ab3",
      backgroundColor: "#166ab3",
      "& + $iOSBar": {
        backgroundColor: "#666",
      },
    },
    transition: theme.transitions.create("transform", {
      duration: theme.transitions.duration.shortest,
      easing: theme.transitions.easing.sharp,
    }),
  },
  iOSChecked: {
    transform: "translateX(15px)",
    "& + $iOSBar": {
      opacity: 1,
      border: "none",
    },
  },
  iOSBar: {
    borderRadius: 13,
    width: 42,
    height: 26,
    marginTop: -13,
    marginLeft: -21,
    border: "solid 1px",
    // borderColor: theme.palette.grey[400],
    // backgroundColor: theme.palette.grey[50],
    opacity: 1,
    transition: theme.transitions.create(["background-color", "border"]),
  },
  iOSIcon: {
    width: 24,
    height: 24,
  },
  iOSIconChecked: {
    boxShadow: theme.shadows[1],
  },
  expand: {
    transform: "rotate(0deg)",
    transition: theme.transitions.create("transform", {
      duration: theme.transitions.duration.shortest,
    }),
  },
  expandOpen: {
    transform: "rotate(45deg)",
  },

  educationGrades: [],
  allEducationalDetails: [],
});

class PastComp extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      datareceived: false,
      showform: false,
      isShuffle: false,
      maxDate: new Date(),
      rangeDate: [],
      allEducationalDetails: [],
      educationGrades: [],
      country: [],
      stateprovince: [],
      cityzone: [],
      workroles: [],
      allExperienceDetails: [],
      educationgradeid: "",
      institutename: "",
      universityname: "",
      fromdate: "",
      todate: "",
      workroleid: "",
      selectedworkrole: {},
      companyname: "",
      companyaddress: "",
      countryid: "",
      selectedCountry: {},
      stateid: "",
      selectedState: {},
      cityid: "",
      selectedCity: {},
      companydoj: "",
      separationdate: "",
      isEdit: false,
      defaultExpMsg: true,
      defaultEduMsg: true,
      EditPerticularEdu: false,
      EditPerticularExp: false,
      hideButton: false,
      minDate: new Date("01-01-1900"),
      isbuttonDisabled: false,
      currentEdit: "",
      expanded: "false",
      flag: 0,
      showBtn: false,
    };
    this.getIntroComponent = this.getIntroComponent.bind(this);
    this.getViewComponent = this.getViewComponent.bind(this);
    this.getEditComponent = this.getEditComponent.bind(this);
    // this.DelProformaInvoice=this.DelProformaInvoice.bind(this);
    this.EditExp = this.EditExp.bind(this);
    this.closeForm = this.closeForm.bind(this);
  }

  componentDidMount() {
    this.getCountry();
    this.GetWorkRole();
    const { SubscriptionInfo } = createstore.getState();
    const { accountid } = SubscriptionInfo.SubscriptionData;
    const { subscriptionid } = SubscriptionInfo.SubscriptionData;
    const { countrytimezoneid } = SubscriptionInfo.SubscriptionData;
    // let employeeid = SubscriptionInfo.SubscriptionData.employeeid;
    const DateFormat = get(
      SubscriptionInfo,
      "SubscriptionData.dateformatname",
      "",
    );
    let ShortDateFormat =
      typeof DateFormat === "string" ? DateFormat.split(" ") : [""];
    ShortDateFormat = ShortDateFormat[0];
    let employeeid;
    employeeid = SubscriptionInfo.SubscriptionData.employeeid;

    const { AuthenticationAction } = createstore.getState();
    if (AuthenticationAction.IsFulfilled) {
      employeeid = AuthenticationAction.login.employeeid;
    }
    const { colleagueid } = this.props.match.params;
    const masterprofileid = get(
      AuthenticationAction,
      "login.masterprofileid",
      9,
    );
    const { permissions } = this.props;
    console.log("permissions: ", permissions);
    let hideButton;
    permissions.editable
      ? colleagueid && colleagueid != employeeid
        ? masterprofileid != 9
          ? (hideButton = true)
          : (hideButton = false)
        : (hideButton = false)
      : masterprofileid != 9
      ? (hideButton = true)
      : (hideButton = false);

    this.setState(
      {
        accountid,
        subscriptionid,
        countrytimezoneid,
        employeeid,
        ShortDateFormat,
        colleagueid,
        hideButton,
        masterprofileid
      },
      () => {
        this.GetExperienceDetails();
        // this.state.isShuffle ? this.GetExperienceDetails() : this.GetEducationalDetails();
      },
    );
  }

  handleChange(event) {
    this.setState({ currentEdit: event.target.value, isEdit: false });
  }

  ClearAll() {
    this.setState({
      educationgradeid: "",
      institutename: "",
      universityname: "",
      fromdate: "",
      todate: "",
      workroleid: "",
      selectedworkrole: { displayname: "Select Work Role", displayvalue: "" },
      companyname: "",
      companyaddress: "",
      countryid: "",
      selectedCountry: { displayname: "Select Country", displayvalue: "" },
      stateid: "",
      selectedState: { displayname: "Select State", displayvalue: "" },
      cityid: "",
      selectedCity: { displayname: "Select City", displayvalue: "" },
      companydoj: "",
      separationdate: "",
      perticularExp: {},
      EditPerticularEdu: false,
      EditPerticularExp: false,
      flag: false,
    });
  }

  UpdateSelectedId(name, e) {
    this.setState({ [name]: e.target.value });
  }

  UpdateData(name, e) {
    this.setState({ [name]: e.target.value });
  }

  UpdateDate = (name, e) => {
    this.setState({ [name]: e.value });
  };

  UpdateSelectedDropdownItem(name, HtField, selectedItem) {
    if (name === "countryid") {
      this.setState(
        {
          countryid: selectedItem.displayvalue,
          selectedCountry: selectedItem,
          stateid: "",
          cityid: "",
          selectedState: { displayname: "Select State", displayvalue: "" },
          selectedCity: { displayname: "Select City", displayvalue: "" },
        },
        () => {
          this.getState();
          this.getCity();
        },
      );
    }
    if (name === "stateid") {
      this.setState(
        {
          stateid: selectedItem.displayvalue,
          selectedState: selectedItem,
          cityid: "",
          selectedCity: { displayname: "Select City", displayvalue: "" },
        },
        () => {
          this.getCity();
        },
      );
    }
    if (name === "cityid") {
      this.setState({
        cityid: selectedItem.displayvalue,
        selectedCity: selectedItem,
      });
    }
    if (name === "workroleid") {
      this.setState({
        workroleid: selectedItem.displayname,
        selectedworkrole: selectedItem,
      });
    }
  }

  closeDate(args) {
    if (!args.date) {
      return;
    }
    const date = args.date.split(" - ");
    const startdate = date[0].trim();
    const enddate = date[1].trim();
    this.setState({ startdate, enddate });
  }

  expDate(args) {
    if (!args.date) {
      return;
    }
    const date = args.date.split(" - ");
    const companydoj = date[0].trim();
    const separationdate = date[1].trim();
    this.setState({ companydoj, separationdate });
  }

  Deleteconfirmation(item) {
    this.setState({ isEdit: "false" });
    this.props.enqueueSnackbar("Are you sure you want to delete?", {
      variant: "warning",

      action: [
        <Button
          color="inherit"
          size="small"
          onClick={
            item.companyname
              ? this.DeleteExp.bind(this, item)
              : this.DeleteEdu.bind(this, item)
          }
        >
          Delete
        </Button>,
        // :this.DeleteEdu.bind(this, item)
        <Button
          color="inherit"
          size="small"
          onClick={() => {
            this.setState({ isEdit: false });
            this.props.closeSnackbar();
          }}
        >
          Dismiss
        </Button>,
      ],
    });
  }

  OnConform = () => {
    this.setState({
      flag: !this.state.flag,
      expanded: true,
      showform: !this.state.showform,
      isEdit: !this.state.isEdit,
      showBtn: true,
    });
  };

  getCountry() {
    instance
      .get("superuser/allcountry")
      .then((result) => {
        const country = [];
        country.push(
          { displayname: "Select Country", displayvalue: "" },
          ...result.data.result,
        );
        this.setState({ country });
      })
      .catch((error) => {
        const CommonError = error.response
          ? error.response.data.error.message
          : error.message;
        this.props.enqueueSnackbar(CommonError, { variant: "error" });
      });
  }

  getState() {
    if (this.state.countryid) {
      const URL = `superuser/statebycountryid/${this.state.countryid}`;
      instance
        .get(URL)
        .then((result) => {
          const stateprovince = [];
          stateprovince.push(
            { displayname: "Select State", displayvalue: "" },
            ...result.data.result,
          );
          this.setState({ stateprovince }, () => {
            // this.setState({ selectedState: stateprovince.find(x => x.displayvalue == exp.stateid) })
          });
        })
        .catch((error) => {
          const CommonError = error.response
            ? error.response.data.error.message
            : error.message;
          this.props.enqueueSnackbar(CommonError, { variant: "error" });
        });
    } else {
      const stateprovince = [
        {
          displayname: "Select State",
          displayvalue: "",
        },
      ];
      const cityzone = [
        {
          displayname: "Select City",
          displayvalue: "",
        },
      ];
      this.setState({ stateprovince, cityzone }, () => {
        // this.setState({ selectedState: this.state.stateprovince.find(x => x.displayvalue == exp.stateid) })
      });
    }
  }

  getCity() {
    if (this.state.stateid && this.state.countryid) {
      const URL = `superuser/citybystateid/${this.state.stateid}`;
      instance
        .get(URL)
        .then((result) => {
          const cityzone = [];
          cityzone.push(
            { displayname: "Select City", displayvalue: "" },
            ...result.data.result,
          );
          this.setState({ cityzone }, () => {
            // this.setState({ selectedCity: this.state.cityzone.find(x => x.displayvalue == exp.cityid) })
          });
        })
        .catch((error) => {
          const CommonError = error.response
            ? error.response.data.error.message
            : error.message;
          this.props.enqueueSnackbar(CommonError, { variant: "error" });
        });
    } else {
      const cityzone = [
        {
          displayname: "Select City",
          displayvalue: "",
        },
      ];
      this.setState({ cityzone }, () => {
        // this.setState({ selectedCity: this.state.cityzone.find(x => x.displayvalue == exp.cityid) })
      });
    }
  }

  GetWorkRole(name) {
    instance
      .get("superuser/workrole")
      .then((result) => {
        const workroles = [];
        workroles.push(
          { displayname: "Select work roles", displayvalue: "" },
          ...result.data.result,
        );

        const selectedworkrole = workroles.find(
          (work) => work.displayname == name,
        );
        this.setState({
          workroles,
          selectedworkrole: selectedworkrole && selectedworkrole,
          workroleid: selectedworkrole && selectedworkrole.displayvalue,
        });
      })
      .catch((error) => {
        this.setState({ CommonError: error.message });
      });
  }

  AddExperienceDetails() {
    this.setState({ isbuttonDisabled: true });
    const data = {
      employeeexperienceid: this.state.employeeexperienceid || null,
      workrolename: this.state.selectedworkrole
        ? this.state.selectedworkrole.displayvalue == 0
          ? null
          : this.state.selectedworkrole.displayname
        : null,
      companyname: this.state.companyname,
      companyaddress: this.state.companyaddress,
      countryid: this.state.countryid,
      stateid: this.state.stateid,
      cityid: this.state.cityid,
      companydoj: convertDateForBackend(this.state.companydoj),
      separationdate: convertDateForBackend(this.state.separationdate),
      employeeid: this.props.colleagueid || this.state.employeeid,
    };
    if (!createstore.getState().AuthenticationAction.IsFulfilled) {
      Object.assign(data, {
        accountid: this.state.accountid,
        subscriptionid: this.state.subscriptionid,
        timezoneid: this.state.countrytimezoneid,
        employeeid: this.props.colleagueid || this.state.employeeid,
      });
    }
    delete data.employeeexperienceid;
    data.employeeexperienceid = this.state.employeeexperienceid || null;
    let s = convertDateForBackend(data.companydoj);
    s = moment(s, "YYYY-MM-DD").startOf("month").format("YYYY-MM-DD");
    let e = convertDateForBackend(data.separationdate);
    e = moment(e, "YYYY-MM-DD").endOf("month").format("YYYY-MM-DD");
    data.companydoj = s;
    data.separationdate = convertDateForBackend(e);
    if (
      !data.companydoj ||
      // || !data.separationdate
      !data.workrolename ||
      !data.cityid ||
      !data.companyname ||
      !data.stateid ||
      !data.countryid ||
      !data.companyaddress
    ) {
      this.props.enqueueSnackbar("Please fill required fileds", {
        variant: "error",
      });
      this.setState({ isbuttonDisabled: false });
      return;
    }
    const URL = "employee/insertupdateempexperience";
    instance
      .post(URL, data)
      .then(() => {
        this.props.enqueueSnackbar("Save successfully", { variant: "success" });
        this.setState(
          {
            isEdit: false,
            defaultExpMsg: false,
            workroleid: "",
            employeeexperienceid: "",
            companyname: "",
            companyaddress: "",
            countryid: "",
            stateid: "",
            cityid: "",
            companydoj: new Date(),
            separationdate: new Date(),
            selectedworkrole: {
              displayname: "Select Work Role",
              displayvalue: "",
            },
            selectedCountry: {
              displayname: "Select Country",
              displayvalue: "",
            },
            selectedState: { displayname: "Select State", displayvalue: "" },
            selectedCity: { displayname: "Select City", displayvalue: "" },
            EditPerticularExp: false,
            perticularExp: {},
          },
          () => {
            this.GetExperienceDetails();
            this.props.UpdateStrength(true);
            this.setState({ isbuttonDisabled: false });
          },
        );
      })
      .catch((error) => {
        this.setState({ isbuttonDisabled: false });
        const CommonError = error.response
          ? error.response.data.error.message
          : error.message;
        this.props.enqueueSnackbar(CommonError, { variant: "error" });
      });
  }

  GetExperienceDetails() {
    const URL = "employee/getempallexperience";
    let data;
    if (createstore.getState().AuthenticationAction.IsFulfilled) {
      if (this.state.colleagueid) {
        data = {
          employeeid: this.state.colleagueid,
        };
      } else {
        data = {};
      }
    } else {
      data = {
        accountid: this.state.accountid,
        subscriptionid: this.state.subscriptionid,
        timezoneid: this.state.countrytimezoneid,
        employeeid: this.state.employeeid,
      };
    }
    instance
      .post(URL, data)
      .then((result) => {
        let allExperienceDetails = [];
        result.data.result.length > 0
          ? (allExperienceDetails = result.data.result)
          : (allExperienceDetails = []);
        const flag = allExperienceDetails.length == 0 ? 0 : 1;
        this.setState({ allExperienceDetails, datareceived: true, flag });
      })
      .catch((error) => {
        const CommonError = error.response
          ? error.response.data.error.message
          : error.message;
        this.props.enqueueSnackbar(CommonError, { variant: "error" });
      });
  }

  AddExp = (item) => {
    this.getCountry();
    this.GetWorkRole();
    this.setState(
      {
        perticularExp: null,
        employeeexperienceid: null,
        workroleid: null,
        companyname: null,
        companyaddress: null,
        countryid: null,
        stateid: null,
        cityid: null,
        companydoj: null,
        separationdate: null,
        isEdit: null,
        currentEdit: null,
        EditPerticularExp: null,
        flag: 2,
      },
      () => {
        const selectedCountry = this.state.country.find(
          (x) => x.displayvalue == item.countryid,
        );
        const selectedworkrole = this.state.workroles.find(
          (x) => x.displayvalue == item.workroleid,
        );
        this.setState({ selectedCountry, selectedworkrole });
        if (item.countryid) {
          this.getState();
          setTimeout(
            () =>
              this.setState({
                selectedState: this.state.stateprovince.find(
                  (x) => x.displayvalue == item.stateid,
                ),
              }),
            300,
          );
        }
        if (item.stateid) {
          this.getCity();
          setTimeout(
            () =>
              this.setState({
                selectedCity: this.state.cityzone.find(
                  (x) => x.displayvalue == item.cityid,
                ),
              }),
            300,
          );
        }
      },
    );
  };

  EditExp = (item) => {
    this.getCountry();
    this.GetWorkRole(item.workrolename);
    this.setState(
      {
        perticularExp: item,
        employeeexperienceid: item.employeeexperienceid,
        // workroleid: item.workroleid,
        // selectedworkrole: item.workrolename,
        companyname: item.companyname,
        companyaddress: item.companyaddress,
        countryid: item.countryid,
        stateid: item.stateid,
        cityid: item.cityid,
        companydoj: item.companydoj,
        separationdate: item.separationdate,
        isEdit: true,
        currentEdit: "experience",
        EditPerticularExp: true,
        flag: 2,
      },
      () => {
        const selectedCountry = this.state.country.find(
          (x) => x.displayvalue == item.countryid,
        );
        // let selectedworkrole = this.state.workroles.find(x => x.displayvalue == item.workroleid);
        this.setState({ selectedCountry });
        if (item.countryid) {
          this.getState();
          setTimeout(
            () =>
              this.setState({
                selectedState: this.state.stateprovince.find(
                  (x) => x.displayvalue == item.stateid,
                ),
              }),
            300,
          );
        }
        if (item.stateid) {
          this.getCity();
          setTimeout(
            () =>
              this.setState({
                selectedCity: this.state.cityzone.find(
                  (x) => x.displayvalue == item.cityid,
                ),
              }),
            300,
          );
        }
      },
    );
  };

  DeleteExp(item) {
    this.props.closeSnackbar();
    let data;
    if (createstore.getState().AuthenticationAction.IsFulfilled) {
      // if (this.state.colleagueid) {
      //   data = {
      //     employeeid: this.state.colleagueid,
      //   };
      // } else {
      //   data = {};
      // } 
      if(this.state.masterprofileid && this.state.masterprofileid == 9){
        data = {employeeid: this.props.colleagueid || this.state.employeeid};
      }
     
    } else {
      data = {
        accountid: this.state.accountid,
        subscriptionid: this.state.subscriptionid,
        timezoneid: this.state.countrytimezoneid,
        employeeid: this.state.employeeid,
      };
    }
    // if (createstore.getState().AuthenticationAction.IsFulfilled) {
    //   data = {};
    // } else {
    //   data = {
    //     // "accountid": this.state.accountid,
    //     // "subscriptionid": this.state.subscriptionid,
    //     timezoneid: this.state.countrytimezoneid,
    //     employeeid: this.props.colleagueid || this.state.employeeid,
    //   };
    // }
    const URL = `/employee/deleteempexperience/${item.employeeexperienceid}`;
    instance
      .delete(URL, {data})
      .then(() => {
        this.setState(
          {
            perticularExp: {},
            employeeexperienceid: "",
            workroleid: "",
            companyname: "",
            companyaddress: "",
            countryid: "",
            stateid: "",
            cityid: "",
            companydoj: new Date(),
            separationdate: new Date(),
            selectedworkrole: {
              displayname: "Select Work Role",
              displayvalue: "",
            },
            selectedCountry: {
              displayname: "Select Country",
              displayvalue: "",
            },
            selectedState: { displayname: "Select State", displayvalue: "" },
            selectedCity: { displayname: "Select City", displayvalue: "" },
            EditPerticularExp: false,
            isEdit: false,

            // country : [],
            // stateprovince : [],
            // cityzone : []
          },
          () => {
            this.props.enqueueSnackbar("deleted successfully", {
              variant: "success",
            });
            this.GetExperienceDetails();
            this.props.UpdateStrength(true);
          },
        );
      })
      .catch((error) => {
        const CommonError = error.response
          ? error.response.data.error.message
          : error.message;
        this.props.enqueueSnackbar(CommonError, { variant: "error" });
      });
  }

  closeForm() {
    this.ClearAll();
    this.setState({
      flag: this.state.allExperienceDetails.length < 1 ? 0 : 1,
      isEdit: false,
      showform: false,
      currentEdit: "",
    });
  }

  SetFlag = (flagData) => {
    this.setState({
      flag: flagData,
    });
  };

  getIntroComponent() {
    const { hideButton } = this.state;
    console.log("hideButton: ", hideButton);
    return (
      <div>
        <Grid container>
          <Grid item xs={12} md={12} sm={12}>
            {!hideButton ? (
              <CreateComp
                text="Success and failure is nothing but experience. Tell us more about your experience below."
                heading="Past experience"
                onCreate={this.SetFlag.bind(this, 2)}
                imageSrc={addressEmployee}
              />
            ) : (
              <NoRecordFound />
            )}
          </Grid>
        </Grid>
      </div>
    );
  }

  getViewComponent() {
    const { allExperienceDetails, hideButton } = this.state;
    return (
      <div>
        {allExperienceDetails.map((exp) => (
          <div className="profile-view-block">
            <If condition={!hideButton}>
              <div className="position-rel">
                <svg
                  className={"address-edit cursour-pointer"}
                  onClick={() => this.EditExp(exp)}
                  width="24"
                  style={{ marginRight: 40 }}
                  height="24"
                  viewBox="0 0 24 24"
                >
                  <path d="M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM5.92 19H5v-.92l9.06-9.06.92.92L5.92 19zM20.71 5.63l-2.34-2.34c-.2-.2-.45-.29-.71-.29s-.51.1-.7.29l-1.83 1.83 3.75 3.75 1.83-1.83c.39-.39.39-1.02 0-1.41z" />
                </svg>
                <svg
                  className={"address-edit cursour-pointer"}
                  onClick={() => this.Deleteconfirmation(exp)}
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path d="M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zM8 9h8v10H8V9zm7.5-5l-1-1h-5l-1 1H5v2h14V4z" />
                  <path fill="none" d="M0 0h24v24H0V0z" />
                </svg>
              </div>
            </If>

            <div className="width90">
              <div className="position-rel">
                <div className="address-data">
                  {/* <span><FormattedMessage id="LbWorkRoleName" defaultMessage="Work Role Name" /></span><br /> */}
                  {exp.workrolename}
                </div>
              </div>
              <div className="position-rel">
                <div className="address-data">
                  {/* <span><FormattedMessage id="LbCompanyName" defaultMessage="Company Name" /></span><br /> */}
                  {exp.companyname}
                </div>
              </div>
              <div className="position-rel">
                <div className="address-data">
                  {/* <span><FormattedMessage id="LbCompanyAddress" defaultMessage="Company Address" /></span><br /> */}
                  {exp.companyaddress}
                </div>
              </div>
              <div className="position-rel">
                <div className="address-data">
                  {/* <span><FormattedMessage id="LbExperienceDuration" defaultMessage="Duration" /></span><br /> */}
                  {moment(exp.companydoj).format("MMM-YYYY")} to{" "}
                  {exp.separationdate
                    ? moment(exp.separationdate).format("MMM-YYYY")
                    : "Present"}
                </div>
              </div>
            </div>
          </div>
        ))}
        {!hideButton && (
          <div
            // className={
            //   this.state.hideButton ? "hide-button" : "add-more-button"
            // }
            className="add-more-button"
            onClick={this.AddExp}
          >
            <Button variant="contained" color="primary" className="no-shadow">
              Add More
            </Button>
          </div>
        )}
      </div>
    );
  }

  getEditComponent() {
    return (
      <div className="emp-from-wrapper work-experience imp-dates">
        <div className="form-height">
          <div id="div">
            <div className="custom-form-box profile-work-exp">
              <div className="inner-wrapper opaque">
                <div className="form-group">
                  <p className="input-form-label">
                    <FormattedMessage
                      id="LbCompanyName"
                      defaultMessage="Company name"
                    />
                  </p>
                  <TextField
                    id="companyname"
                    // label={<FormattedMessage id="LbCompanyName" defaultMessage="Company name" />}
                    // defaultValue="Company Name"
                    margin="dense"
                    variant="outlined"
                    onChange={this.UpdateData.bind(this, "companyname")}
                    value={this.state.companyname}
                    inputProps={{ maxLength: 90 }}
                    tabIndex="2"
                    autoFocus
                  />
                </div>
              </div>
              <div className="inner-wrapper opaque">
                <div className="margin-bottom-20 ">
                  <p className="input-form-label">
                    <FormattedMessage
                      id="LbExperienceCompanyDoj"
                      defaultMessage="Start Date"
                    />
                  </p>
                  <DatePickerComponent
                    className="start-date"
                    // onChange={this.setValue.bind(this, option)}
                    start="Decade"
                    depth="Year"
                    max={new Date()}
                    allowEdit={false}
                    // onClick={() => this.dateObj1.show()}
                    // ref={(date)) => this.dateObj1 = date}
                    format={getEJ2CalenderMonthFormat()}
                    change={(e) => this.UpdateDate("companydoj", e)}
                    value={this.state.companydoj}
                    placeholder="from"
                    width={"430px"}
                  />
                </div>
              </div>
              <div className="inner-wrapper opaque">
                <div className="margin-bottom-20 work-exp-datepicker">
                  <p className="input-form-label">
                    <FormattedMessage
                      id="LbExperienceSeparationDate"
                      defaultMessage="End Date"
                    />
                    <span> (Optional) </span>
                  </p>
                  <DatePickerComponent
                    placeholder="To"
                    format={getEJ2CalenderMonthFormat()}
                    width={"430px"}
                    start="Decade"
                    depth="Year"
                    min={this.state.companydoj}
                    // onClick={() => this.dateObj2.show()}
                    // ref={(date)) => this.dateObj2 = date}
                    max={this.state.maxDate}
                    value={this.state.separationdate}
                    change={(e) => this.UpdateDate("separationdate", e)}
                  />
                </div>
              </div>
              <div className="inner-wrapper opaque" tabIndex="4">
                <div className="form-group">
                  <p className="input-form-label">
                    <FormattedMessage
                      id="LbWorkRole"
                      defaultMessage="Select Work Role"
                    />
                  </p>
                  <Select
                    className="selectsearch"
                    onChange={this.UpdateSelectedDropdownItem.bind(
                      this,
                      "workroleid",
                      "Htworkid",
                    )}
                    options={this.state.workroles}
                    getOptionLabel={(option) => option.displayname}
                    getOptionValue={(option) => option.displayname}
                    value={this.state.selectedworkrole}
                    placeholder="Select Work Role"
                  />
                </div>
              </div>
              <div className="inner-wrapper opaque">
                <div className="form-group">
                  <p className="input-form-label">
                    <FormattedMessage
                      id="LbCompanyAddress"
                      defaultMessage="Company Address"
                    />
                  </p>
                  <TextField
                    id="outlined-bare"
                    // label={<FormattedMessage id="LbCompanyAddress" defaultMessage="Company Address" />}
                    // defaultValue="Company Address"
                    margin="dense"
                    variant="outlined"
                    onChange={this.UpdateData.bind(this, "companyaddress")}
                    value={this.state.companyaddress}
                    inputProps={{ maxLength: 90 }}
                    tabIndex="3"
                  />
                </div>
              </div>
              <div className="inner-wrapper opaque" tabIndex="5">
                <div className="form-group">
                  <p className="input-form-label">
                    <FormattedMessage
                      id="LbCountryName"
                      defaultMessage="Select Country"
                    />
                  </p>
                  <Select
                    className="selectsearch"
                    onChange={this.UpdateSelectedDropdownItem.bind(
                      this,
                      "countryid",
                      "HtCountry",
                    )}
                    options={this.state.country}
                    getOptionLabel={(option) => option.displayname}
                    getOptionValue={(option) => option.displayvalue}
                    value={this.state.selectedCountry}
                    placeholder="Select Country"
                  />
                </div>
              </div>
              <div className="inner-wrapper opaque" tabIndex="6">
                <div className="form-group">
                  <p className="input-form-label">
                    <FormattedMessage
                      id="LbCountryState"
                      defaultMessage="Select State"
                    />
                  </p>
                  <Select
                    className="selectsearch"
                    onChange={this.UpdateSelectedDropdownItem.bind(
                      this,
                      "stateid",
                      "HtState/Province",
                    )}
                    options={this.state.stateprovince}
                    getOptionLabel={(option) => option.displayname}
                    getOptionValue={(option) => option.displayvalue}
                    value={this.state.selectedState}
                    placeholder="Select State"
                  />
                </div>
              </div>
              <div className="inner-wrapper opaque" tabIndex="7">
                <div className="form-group">
                  <p className="input-form-label">
                    <FormattedMessage
                      id="LbCountryCity"
                      defaultMessage="Select City"
                    />
                  </p>
                  <Select
                    className="selectsearch"
                    onChange={this.UpdateSelectedDropdownItem.bind(
                      this,
                      "cityid",
                      "HtCity/Zone",
                    )}
                    options={this.state.cityzone}
                    getOptionLabel={(option) => option.displayname}
                    getOptionValue={(option) => option.displayvalue}
                    value={this.state.selectedCity}
                    placeholder="Select City"
                  />
                </div>
              </div>
              <div className="margin-top-15">
                <span
                  className={this.state.isbuttonDisabled ? "hide-event" : "ADD"}
                  onClick={this.AddExperienceDetails.bind(this)}
                  tabIndex="8"
                >
                  <Button
                    variant="contained"
                    size="large"
                    color="primary"
                    className="lifeevent-btn "
                  >
                    {this.state.EditPerticularExp || this.state.flag == 2 ? (
                      <span>
                        <FormattedMessage id="BtSave" defaultMessage="SAVE" />
                      </span>
                    ) : (
                      <span>
                        <FormattedMessage id="BtAdd" defaultMessage="Add" />
                      </span>
                    )}
                  </Button>
                </span>
                <span
                  color="inlineClass"
                  className="margin-left-5"
                  onClick={this.closeForm}
                  tabIndex="9"
                >
                  <Button size="large" className="lifeevent-btn">
                    <span>
                      <FormattedMessage id="BtCancel" defaultMessage="Cancel" />
                    </span>
                  </Button>
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  render() {
    const { flag, datareceived } = this.state;
    return (
      <div>
        <If condition={datareceived}>
          <If condition={flag == 0}>{this.getIntroComponent()}</If>
          <If condition={flag == 1}>{this.getViewComponent()}</If>
          <If condition={flag == 2}>{this.getEditComponent()}</If>
        </If>
      </div>
    );
  }
}

export default withStyles(styles, { withTheme: true })(withSnackbar(PastComp));
